function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { ClassNames } from '@emotion/core';
import olStyles from 'ol/ol.css';
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import GeoJSON from 'ol/format/GeoJSON';
import Draw from 'ol/interaction/Draw.js';
import TileLayer from 'ol/layer/Tile.js';
import VectorLayer from 'ol/layer/Vector.js';
import OSMSource from 'ol/source/OSM.js';
import VectorSource from 'ol/source/Vector.js';
import { jsx as ___EmotionJSX } from "@emotion/core";
const formatOptions = {
  dataProjection: 'EPSG:4326',
  featureProjection: 'EPSG:3857'
};

function getDefaultFormat() {
  return new GeoJSON(formatOptions);
}

function getDefaultMap(target, featuresLayer) {
  return new Map({
    target,
    layers: [new TileLayer({
      source: new OSMSource()
    }), featuresLayer],
    view: new View({
      center: [0, 0],
      zoom: 2
    })
  });
}

export default function withMapControl({
  getFormat,
  getMap
} = {}) {
  var _class, _temp;

  return _temp = _class = class MapControl extends React.Component {
    constructor(props) {
      super(props);
      this.mapContainer = /*#__PURE__*/React.createRef();
    }

    componentDidMount() {
      const {
        field,
        onChange,
        value
      } = this.props;
      const format = getFormat ? getFormat(field) : getDefaultFormat(field);
      const features = value ? [format.readFeature(value)] : [];
      const featuresSource = new VectorSource({
        features,
        wrapX: false
      });
      const featuresLayer = new VectorLayer({
        source: featuresSource
      });
      const target = this.mapContainer.current;
      const map = getMap ? getMap(target, featuresLayer) : getDefaultMap(target, featuresLayer);

      if (features.length > 0) {
        map.getView().fit(featuresSource.getExtent(), {
          maxZoom: 16,
          padding: [80, 80, 80, 80]
        });
      }

      const draw = new Draw({
        source: featuresSource,
        type: field.get('type', 'Point')
      });
      map.addInteraction(draw);
      const writeOptions = {
        decimals: field.get('decimals', 7)
      };
      draw.on('drawend', ({
        feature
      }) => {
        featuresSource.clear();
        onChange(format.writeGeometry(feature.getGeometry(), writeOptions));
      });
    }

    render() {
      return ___EmotionJSX(ClassNames, null, ({
        cx,
        css
      }) => ___EmotionJSX("div", {
        className: cx(this.props.classNameWrapper, css`
                  ${olStyles};
                  padding: 0;
                  overflow: hidden;
                `),
        ref: this.mapContainer
      }));
    }

  }, _defineProperty(_class, "propTypes", {
    onChange: PropTypes.func.isRequired,
    field: PropTypes.object.isRequired,
    value: PropTypes.node
  }), _defineProperty(_class, "defaultProps", {
    value: ''
  }), _temp;
}